import { render, staticRenderFns } from "./EventItemVariation.vue?vue&type=template&id=5eff8350&scoped=true"
import script from "./EventItemVariation.vue?vue&type=script&lang=js"
export * from "./EventItemVariation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eff8350",
  null
  
)

export default component.exports